import React, { useState, useEffect } from 'react';
import { useNavigation } from './NavigationContext';
import { navigationData } from '../../data/navigationData';
import { NavigationItem } from '../../types/navigation';
import './MobileMenu.css';

const MobileMenu: React.FC = () => {
  const { state, updateState, closeMobileMenu } = useNavigation();
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (state.mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [state.mobileMenuOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && state.mobileMenuOpen) {
        closeMobileMenu();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [state.mobileMenuOpen, closeMobileMenu]);

  const handleGlobalNavigation = (item: NavigationItem) => {
    const path = item.href.split('/')[1] || 'home';
    
    updateState({
      section: path,
      product: null,
      page: null,
      path: item.href,
      mobileMenuOpen: false
    });
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simple search implementation
    if (searchQuery.toLowerCase().includes('finance')) {
      updateState({
        section: 'pros',
        product: 'finance',
        page: 'overview',
        path: '/pros/finance',
        mobileMenuOpen: false
      });
    } else if (searchQuery.toLowerCase().includes('leads')) {
      updateState({
        section: 'pros',
        product: 'leads',
        page: 'overview',
        path: '/pros/leads',
        mobileMenuOpen: false
      });
    }
    setSearchQuery('');
  };

  if (!state.mobileMenuOpen) return null;

  return (
    <div className="mobile-menu-overlay" onClick={closeMobileMenu}>
      <div className="mobile-menu-fullscreen" onClick={(e) => e.stopPropagation()}>
        <div className="mobile-menu-header">
          <div className="mobile-menu-brand">
            <div className="brand-logo">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="8" fill="var(--color-primary)"/>
                <path d="M8 24V8h3v13h10v3H8z" fill="white"/>
                <path d="M14 18V12h3v6h-3z" fill="white"/>
                <path d="M20 20V10h3v10h-3z" fill="white"/>
              </svg>
            </div>
            <span className="brand-text">{navigationData.global.brand}</span>
          </div>
          <button 
            className="mobile-menu-close" 
            onClick={closeMobileMenu}
            aria-label="Close mobile menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="mobile-menu-content">
          <div className="mobile-nav-items">
            {navigationData.global.items.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`mobile-nav-item ${state.section === item.href.split('/')[1] ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleGlobalNavigation(item);
                }}
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="mobile-search">
            <form onSubmit={handleSearchSubmit}>
              <input
                type="search"
                className="form-control"
                placeholder="Search..."
                aria-label="Search"
                value={searchQuery}
                onChange={handleSearch}
              />
            </form>
          </div>

          <div className="mobile-cta">
            {navigationData.global.cta.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`btn ${item.primary ? 'btn--primary' : 'btn--outline'} btn--full-width`}
                onClick={(e) => {
                  e.preventDefault();
                  handleGlobalNavigation(item);
                }}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;